import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchOpeningDataforForm({ id }) {
  try {
    const query = {
      fields: [
        "id",
        getUserFields("sales_coordinator"),
        "skills.skill.id",
        "skills.skill.name",
        "title",
        "description",
        "status",
        "expertise",
        "opportunity_link",
      ],
    };
    const response = await getItemFromCollection("openings", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
